import {Route,Switch,BrowserRouter } from "react-router-dom";

import DoobiHeader from "components/Headers/DoobiHeader";
import LaundryOrderDetailsViewPage from "components/Doobi/LaundryOrderDetailsView";
// import ScanQrPage from "components/Doobi/ScanQr";
// import TagQrCodesPage from "components/Doobi/TagQrCodes";
// import ScanQrCodesPage from "components/Doobi/ScanQrCodes";
import LaundryOrdersViewTable from "components/Doobi/LaundryOrdersView";

const LaundryOrdersViewRoute = ({ match }) => {
  return (
    <>
  <DoobiHeader section="Laundry Orders" />
    <BrowserRouter>
    <Switch>
      {/* <Route path={`${match.path}/scanQrs/:id`} component={ScanQrCodesPage}/>
      <Route path={`${match.path}/tagQrs/:id`} component={TagQrCodesPage}/>
      <Route path={`${match.path}/scanQr`} component={ScanQrPage}/> */}
      <Route path={`${match.path}/laundryOrder/:id`} component={LaundryOrderDetailsViewPage}/>
      <Route path={`${match.path}/:id`} component={LaundryOrdersViewTable}/>
    </Switch>
    </BrowserRouter>
    </>
    );
  }; 


export default LaundryOrdersViewRoute;
